import { tag } from '@/api'
import {
	TAG_LOADING_STATUS,
	TAG_FETCH,
	TAG_FETCH_ERRORS,
	TAG_FETCH_POPULAR,
	TAG_FETCH_POPULAR_ERROR,
	TAG_DELETE,
	TAG_DELETE_ERRORS,
	TAG_ADD,
	TAG_ADD_ERRORS,
	TAG_CLEAR,
} from './types'

const fetchTags = async (ctx, payload) => {
	ctx.commit(TAG_LOADING_STATUS, true)
	try {
		const { data, headers } = await tag.fetchTags(payload)
		const pageCount = headers['x-pagination-page-count']
		const perPage = headers['x-pagination-per-page']
		const totalCount = headers['x-pagination-total-count']
		const currentPage = headers['x-pagination-current-page']
		ctx.commit(TAG_FETCH, {
			data,
			tagsMeta: {
				pageCount,
				perPage,
				totalCount,
				currentPage,
			},
		})
	} catch (e) {
		ctx.commit(TAG_FETCH_ERRORS, e)
		console.error(e)
	} finally {
		ctx.commit(TAG_LOADING_STATUS, false)
	}
}

const fetchPopularTags = async (ctx, query) => {
	ctx.commit(TAG_LOADING_STATUS, true)
	try {
		const { data } = await tag.fetchPopularTags(query)
		ctx.commit(TAG_FETCH_POPULAR, data)
		ctx.commit(TAG_LOADING_STATUS, false)
	} catch (e) {
		ctx.commit(TAG_FETCH_POPULAR_ERROR, e)
		throw e
	}
}

const fetchPopularTagsWithoutLoader = async (ctx, query) => {
	try {
		const { data } = await tag.fetchPopularTags(query)
		ctx.commit(TAG_FETCH_POPULAR, data)
	} catch (e) {
		ctx.commit(TAG_FETCH_POPULAR_ERROR, e)
		throw e
	}
}

const deleteTag = async (ctx, id) => {
	try {
		await tag.deleteTag(id)
		ctx.commit(TAG_DELETE, id)
	} catch (e) {
		ctx.commit(TAG_DELETE_ERRORS, e)
		throw e
	}
}

const addTag = async (ctx, tagData) => {
	ctx.commit(TAG_LOADING_STATUS, true)
	try {
		const { data } = await tag.addTag(tagData)
		ctx.commit(TAG_ADD, data.data)
		ctx.commit(TAG_LOADING_STATUS, false)
	} catch (e) {
		ctx.commit(TAG_ADD_ERRORS, e)
		throw e
	}
}

const clearTags = async (ctx) => {
	try {
		ctx.commit(TAG_CLEAR)
	} catch (e) {
		ctx.commit(TAG_ADD_ERRORS, e)
		throw e
	}
}

export default {
	fetchTags,
	fetchPopularTags,
	deleteTag,
	addTag,
	fetchPopularTagsWithoutLoader,
	clearTags,
}
